<div class="flex h-full min-h-0 flex-col gap-4">
  <div class="relative mb-4">
    <div class="custom-form custom-form-readonly">
      <app-talking-point-ai
        [analyticsBadgeLoading]="analyticsStatusBadgeLoading()"
        [analyticsKeywordJump]="jumpToNextKeywordFinding"
        [analyticsKeywordJumpTargets]="keywordTableRowIds()"
        [analyticsKeywordJumpTargetsReady]="keywordTableRowIdsReady()"
        [creatorId]="executionAnalytics()?.creatorId"
        [form]="deliverableForm()"
        [creators]="[]"
        [isCustomMode]="true"
        [isExpanded]="true"
        [isViewMode]="true"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
        [showStatusBadge]="executionAnalytics()?.status !== EMatchingType.planned"
      />
    </div>
  </div>

  @if (manualDeliverableStatusConfig().analyticsVisible) {
    <div class="flex flex-col gap-3">
      <h3 class="text-sm font-bold">
        {{ 'pages.campaignDetails.ctaAnalytics.details.detected' | translate }}
        {{ 'pages.campaignDetails.ctaAnalytics.deliverable.' + deliverableType + '.title' | translate | lowercase }}
      </h3>
      <app-timeline-graph
        class="p-3 bg-shikenso-gray-base-24 rounded-2xl"
        [dotGraphData]="dotGraphData()"
        [chartConfiguration]="chartConfiguration()"
        [startTimestamp]="0"
        [endTimestamp]="totalMediaDurationSeconds()"
        (pointSelected)="onDataPointClick($event)"
      />
    </div>

    <div class="flex min-h-0 flex-1 flex-col gap-6 xl:flex-row xl:items-start">
      <div class="flex min-h-0 flex-1 flex-col">
        <ng-container [ngTemplateOutlet]="tableTemplate"></ng-container>
      </div>

      @if (media().length > 0 && shouldRenderInPagePlayer()) {
        <div class="flex justify-center w-full xl:w-[360px] xl:shrink-0 pt-5">
          <app-video-player
            class="w-[360px]"
            [configuration]="videoConfiguration()"
            [seekTime]="seekTime()"
            [protectHeight]="true"
            [videoPlayedContext]="videoPlayedContext"
          />
        </div>
      }
    </div>
  }
</div>

<ng-template #tableTemplate>
  <app-analytics-details-table
    matSort
    [dataSource]="dataSource"
    [dataCount]="dataCount()"
    [displayedColumns]="displayedColumns"
    [sort]="sort()"
    [selectedRowId]="selectedDataId()"
  >
    <ng-container matColumnDef="timestamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'pages.campaignDetails.ctaAnalytics.details.talkingPointAi.videoTime' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.timestamp }}</td>
    </ng-container>
    <ng-container matColumnDef="message">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'pages.campaignDetails.ctaAnalytics.details.talkingPointAi.message' | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        class="max-w-md text-sm"
        matTooltipPosition="above"
        [attr.tabindex]="element.reason ? 0 : null"
        [matTooltip]="element.reason"
        [matTooltipDisabled]="!element.reason"
        [innerHTML]="highlightKeywords(element.message)"
      ></td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div class="flex items-center justify-end gap-1">
          <button mat-icon-button class="mat-secondary-gray-border-button-color" (click)="onRowClick($event, element)">
            <app-icon
              [src]="
                executionAnalyticsWithFindings()?.platformFeature === EPlatformFeature.youtubeVod
                  ? '/icons/arrow-up-right.svg'
                  : '/icons/arrow-right.svg'
              "
              alt="View"
              [size]="12"
            />
          </button>
          @if (manualFindingStatusStore) {
            @if (hasRowPendingDeletions(element)) {
              @if (isVisualizerActing(element.id)) {
                <app-dots-spinner />
              } @else {
                <button
                  mat-icon-button
                  class="mat-secondary-gray-border-button-color"
                  (click)="onRevertRow(element); $event.stopPropagation()"
                >
                  <app-icon src="/icons/redo.svg" alt="Revert" [size]="16" />
                </button>
              }
            } @else if (canDelete()) {
              @if (isFindingInFlight(element.id)) {
                <app-dots-spinner />
              } @else {
                <button
                  mat-icon-button
                  class="mat-secondary-gray-border-button-color"
                  (click)="onDeleteSingleRowFinding(element); $event.stopPropagation()"
                >
                  <app-icon src="/icons/trash.svg" alt="Delete" [size]="16" />
                </button>
              }
            }
          }
        </div>
      </td>
    </ng-container>
  </app-analytics-details-table>
</ng-template>
